import { useQuery } from "@tanstack/react-query"
import { queries } from "../../lib/query-key-factory"

export const useChannelsQuery = () => {
  return useQuery(queries.channels.list()).data || []
}
